import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WorkspaceCreatePage } from '@/features/admin/workspaces/workspace-pages';
import { isWorkspaceType, type WorkspaceType } from '@/features/admin/workspaces/workspace-forms';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Nouvel espace de travail (porting README #85). `?type=` présélectionne le type (Jupyter par défaut). */
export const Route = createFileRoute('/$tenant/workspaces/new')({
  validateSearch: (search: Record<string, unknown>): { type: WorkspaceType } => ({
    type: isWorkspaceType(search['type']) ? search['type'] : 'jupyter',
  }),
  component: NewWorkspaceRoute,
});

function NewWorkspaceRoute() {
  const { tenant } = Route.useParams();
  const { type } = Route.useSearch();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem={type === 'vscode' ? 'vscode' : type === 'rstudio' ? 'rstudio' : 'jupyter'}
      crumbs={[{ label: t('admin.workspaces.title') }, { label: t('admin.workspaces.newTitle') }]}
    >
      <WorkspaceCreatePage tenantId={tenant} type={type} />
    </ConsoleShell>
  );
}
